import React, { useEffect, useLayoutEffect, useState } from "react";
import { useAppSelector, useAppDispatch } from "../../../app/hooks"
import { getWebhookRetryAsync ,getAccountWebHookReceiverLogAsync, updatePagination,updateSearchPagination, setPageSize,setSearchValue} from './WebHookReceiverLogSlice';
import WebHookReceiverLogItem from "./WebHookReceiverLogItem";
import { ViewDetails } from "./ViewDetails";
import WebHookReceiverLogOffCanvas from "./WebHookReceiverLogOffCanvas";
import OffCanvas from '../../../common/OffCanvas';
import { useTranslation } from "react-i18next";
import { useLocation, useNavigate } from "react-router-dom";
import { updatePageIdState, getPagePermissionsAsync } from '../../../common/GlobalSlice';
import CustomPagination from "../../../common/Pagination";
import Select, { StylesConfig } from 'react-select';
import moment from "moment";
import { useDebounce } from "../../../_metronic/helpers";
import Loader from "../../../common/Loader";
import PageSizeSelect from '../../../common/PageSizeSelect';
import { getValueFromResource } from "../../../common/timeLiveFunction";

const colourStyles: StylesConfig = {
    control: (styles) => ({ ...styles, backgroundColor: 'white', width: 75, minHeight: '36px', height: '36px', padding: '-1px', borderColor: '#EBECF0', marginRight: '0px', fontWeight: '400px', color: '#172B4F' })
}

const WebHookReceiverLog = () => {
    const dispatch = useAppDispatch();
    const { t } = useTranslation();
    const offCanvasList = [
        {
            name:getValueFromResource("Filters",dispatch,t),
            width: '500px',
            componentName: <WebHookReceiverLogOffCanvas t={t} />
        },
        {
            name: getValueFromResource("Details",dispatch,t),
            width: "500px",
            componentName: <ViewDetails />
        }
    ];
    const { WebHookReceiverLogList,WebHookReceiverLogCheckedIds, currentPage, pageSize, isSearch, totalItems, start,startRec,pageNo,sortColumn,sortOrder, recordsFiltered,
        optionStatusText,optionStatusValue,optionWebHookEventTypeValue,optionWebHookEventTypeText,startDate,endDate,search,isReload, } = useAppSelector((state) => state.webHookReceiverLog);
    const [showOffCanvas, setShowOffCanvas] = useState(false);
    const [selectedOffCanvas, setSelectedOffCanvas] = useState(offCanvasList[0]); // Store the selected OffCanvas object
    const { pageId, menuList, IsList} = useAppSelector((state) => state.globalState);
    const { isLoading } = useAppSelector((state) => state.webHookReceiverLog);

    const location = useLocation();
    const navigate = useNavigate();
    const options = [{ value: '10', label: '10' }, { value: '20', label: '20' }, { value: '30', label: '30' }, { value: '40', label: '40' }, { value: '50', label: '50' }];

    useLayoutEffect(() => {
        const fetchPagePermissions = async () => {
            if (pageId && pageId !== '') {
                const res = await dispatch(getPagePermissionsAsync(pageId));
                if (!res.payload.IsList) {
                    navigate('../error/403');
                }
            } else if (!pageId && menuList && menuList.length > 0) {
                const routeName = location.pathname.split('/').filter(Boolean)[0];
                const foundItem = menuList.find(item => item.SystemCategoryPageFrontEnd === routeName);
                if (foundItem) {
                    const res = await dispatch(getPagePermissionsAsync(foundItem.SystemSecurityCategoryPageId));
                    if (!res.payload.IsList) {
                        navigate('../error/403');
                    }
                } else {
                    navigate('../error/403');
                }
            }
        };

        fetchPagePermissions();
    }, [dispatch, location.pathname, menuList, navigate, pageId]);

    
    const debouncedSearchTerm = useDebounce(search, 500);


        useEffect(() => {
            const start =  1 * pageSize;
            let SearchParamsValues = `${optionStatusValue},${moment(startDate).format('MM-DD-YYYY')},${moment(endDate).format('MM-DD-YYYY')},${optionWebHookEventTypeValue}`;
            
            dispatch(getAccountWebHookReceiverLogAsync({ currentPage: 1, pageSize: pageSize, start: 0, SearchParamsValues: SearchParamsValues, search: debouncedSearchTerm }));
        }, [debouncedSearchTerm]);

        useEffect(() => {
            let SearchParamsValues = `${optionStatusValue},${moment(startDate).format('MM-DD-YYYY')},${moment(endDate).format('MM-DD-YYYY')},${optionWebHookEventTypeValue}`;
            dispatch(getAccountWebHookReceiverLogAsync({ currentPage: 1, pageSize: pageSize, start: startRec, SearchParamsValues: SearchParamsValues, search: debouncedSearchTerm }));
        }, [pageNo, pageSize, isReload]); 


/*     useEffect(() => {
        if (isSearch && debouncedSearchTerm !== ' ') {
            dispatch(getAccountWebHookReceiverLogAsync());
        }

    }, [debouncedSearchTerm]); 

    useEffect(() => {
        dispatch(getAccountWebHookReceiverLogAsync());
        // startRec == 0 && dispatch(getTimeOffRequestStatusList(sessionAccountEmployeeId))
        // setTab('TimeOffList');
    }, [pageNo, pageSize, sortOrder, sortColumn, isReload]); */
    
    
    
   

    // useEffect(() => {
//         if (isReload) {
//             let SearchParamsValues = `${optionStatusValue},${moment(startDate).format('MM-DD-YYYY')},${moment(endDate).format('MM-DD-YYYY')},${optionWebHookEventTypeValue}`;
//             dispatch(getAccountWebHookReceiverLogAsync({ currentPage: currentPage, pageSize: pageSize, start: start, order: columnIndex, orderDir: direction, SearchParamsValues: SearchParamsValues, search: " " }));
//         }
//     }, [isReload]);

//     useEffect(() => {
//         let SearchParamsValues = `${optionStatusValue},${moment(startDate).format('MM-DD-YYYY')},${moment(endDate).format('MM-DD-YYYY')},${optionWebHookEventTypeValue}`;
//         dispatch(getAccountWebHookReceiverLogAsync({ currentPage: currentPage, pageSize: pageSize, start: start, order: columnIndex, orderDir: direction, SearchParamsValues: SearchParamsValues, search: " " }));
//     }, [dispatch]);

  




    const handleOnClickEvent = () => {
        const commaSeparatedString = WebHookReceiverLogCheckedIds.join(', ');
        dispatch(getWebhookRetryAsync(commaSeparatedString));
    };
    
    const handleFilterOnClickEvent = (selectedObject:any) => {
        setSelectedOffCanvas(selectedObject);
        setShowOffCanvas(true);
    }

    // const handlePageChange = (pageNumber: any) => {
    //     const start = (pageNumber - 1) * pageSize;
    //      let SearchParamsValues = `${optionStatusValue},${moment(startDate).format('MM-DD-YYYY')},${moment(endDate).format('MM-DD-YYYY')},${optionWebHookEventTypeValue}`;
    //      dispatch(getAccountWebHookReceiverLogAsync({ currentPage: pageNumber, pageSize: pageSize, start: start, order: columnIndex, orderDir: direction, SearchParamsValues: SearchParamsValues, search: " " }));
    // };
    
    // const handleSearch = (event: any) => {   
    //     const { value } = event.target;
    //     dispatch(setSearchValue(value))
    // };

    // const handlePageSizeChange = (event: any) => {
    //      const { value } = event;
    //       dispatch(setPageSize(Number(value)));
    //       let SearchParamsValues = `${optionStatusValue},${moment(startDate).format('MM-DD-YYYY')},${moment(endDate).format('MM-DD-YYYY')},${optionWebHookEventTypeValue}`;
    //       dispatch(getAccountWebHookReceiverLogAsync({ currentPage: 1, pageSize: value, start: 0, order: columnIndex, orderDir: direction, SearchParamsValues: SearchParamsValues, search: " " }));
        
    // };
    
    const onHandleSearch = (event: any) => {
        dispatch(updateSearchPagination(event.target.value));
    }

    const onHandlePageChange = (pageNumber: any) => {
        let objects = {
            "startRec": (pageNumber - 1) * Number(pageSize),
            "pageSize": pageSize,
            "pageNo": pageNumber,
            "search": search
        }
        dispatch(updatePagination(objects));
    }

    const onHandlePageSizeChange = (selectedOption: any) => {
        let objects = {
            "startRec": 0,
            "pageSize": selectedOption.value,
            "pageNo": 1,
            "search": search
        }
        dispatch(updatePagination(objects));
    }
    
    return (
        <>
        {isLoading && <Loader />}
             <div className="card card-custom admin-card">
                <div className="card-header card-drop sticky-top bg-white fixed-top">
                    <h3 className="card-title fw-bold mainHeading">
                        {/* {t('Webhook Receiver Log')} */}
                        {getValueFromResource('Webhook Receiver Log',dispatch, t)}
                        </h3>
                    <div className="card-toolbar align-items-center">
                                <div className="position-relative">
                                    <input
                                        type="text"
                                        value={search}
                                        onChange={(e: any) => onHandleSearch(e)}
                                        placeholder=
                                        {getValueFromResource('Search',dispatch, t)}
                                        className="form-control h-35px w-200px fs-7 fw-normal pr-4"
                                        data-kt-user-table-filter="search"

                                    />
                                    <i className="ki-duotone ki-magnifier fs-5 position-absolute top-50 translate-middle-y end-0" style={{ marginRight: '10px' }}  >
                                        <span className="path1"></span>
                                        <span className="path2"></span>
                                    </i>
                                </div>
                                <div className='h-35px w-1px mx-1'></div>
                                <div className="d-flex align-items-center">
                                    {/* <Select
                                        styles={colourStyles}
                                        options={options}
                                        value={options.find(option => parseInt(option.value) == pageSize)}
                                        onChange={handlePageSizeChange}
                                        className='fs-7 fw-normal'

                                    /> */}
                                     <PageSizeSelect onChange={onHandlePageSizeChange} />

                                </div>
                                <div className='bullet bg-secondary h-35px w-1px mx-3'></div>
                                <div>
                                    {(WebHookReceiverLogList.length > 0) ? (
                                        <CustomPagination
                                            currentPage={pageNo}
                                            onPageChange={onHandlePageChange}
                                            pageSize={pageSize}
                                            totalItems={totalItems}
                                            start={startRec}
                                            t={t}
                                            recordsFiltered={recordsFiltered}
                                        >

                                        </CustomPagination>
                                    ) : null}
                                </div>
                            {/* </>
                        } */}
                        {(WebHookReceiverLogList.length > 0 && pageSize < totalItems) &&
                            <div className='bullet bg-secondary h-35px w-1px mx-3'></div>
                        }

                        <button type="button" className="btn  btn-danger btn-bs-btn-font-weight btn-sm"
                            disabled={WebHookReceiverLogCheckedIds.length === 0 ? true : false}
                            onClick={handleOnClickEvent}>
                            {/* {t('Retry Selected')} */}
                            {getValueFromResource('Retry Selected',dispatch, t)}
                        </button>

                        {IsList &&
                            <>
                                &nbsp;
                                <button
                                    id="kt_OffCanvas"
                                    type="button"
                                    className="btn btn-primary  btn-bs-btn-font-weight btn-sm"
                                    onClick={() => handleFilterOnClickEvent(offCanvasList[0])}
                                >
                                    {/* {t('Filters')} */}
                                    {getValueFromResource('Filters',dispatch, t)}

                                </button>
                            </>
                        }
                    </div>
                </div>
                {IsList &&
                    // <div className="card-body">
                    <div className="card-Report-body">
                        <div className="table-responsive">
                            <WebHookReceiverLogItem
                                webHookReceiverLogDetail={WebHookReceiverLogList}
                                onhandleFilterOnClickEvent={handleFilterOnClickEvent}
                                offCanvasObject={offCanvasList[1]}
                                t={t} 
                            />
                        </div>
                    </div>
                }
            </div>
            <OffCanvas
                isOpen={showOffCanvas}
                onClose={() => setShowOffCanvas(false)}
                obj={selectedOffCanvas}
            />
        </>
    )
}

export default WebHookReceiverLog;




// import React, { useState } from "react";
// import { useAppSelector, useAppDispatch } from "../../../app/hooks"
// import {getWebhookRetryAsync } from "./WebHookReceiverLogSlice";
// import WebHookReceiverLogItem from "./WebHookReceiverLogItem";
// import { ViewDetails } from "./ViewDetails";
// import WebHookReceiverLogOffCanvas from "./WebHookReceiverLogOffCanvas";
// import OffCanvas from '../../../common/OffCanvas';
// import { useTranslation } from "react-i18next";


// const WebHookReceiverLog = () => {
//     const { t } = useTranslation();
//     const offCanvasList = [
//         {
//             name:t("Filters"),
//             width: '400px',
//             componentName: <WebHookReceiverLogOffCanvas />
//         },
//         {
//             name: t("Details"),
//             width: "400px",
//             componentName: <ViewDetails />
//         }
//     ];
//     const dispatch = useAppDispatch();
//     const { WebHookReceiverLogList,WebHookReceiverLogCheckedIds } = useAppSelector((state) => state.webHookReceiverLog);
//     const [showOffCanvas, setShowOffCanvas] = useState(false);
//     const [selectedOffCanvas, setSelectedOffCanvas] = useState(offCanvasList[0]); // Store the selected OffCanvas object

//     const handleOnClickEvent = () => {
//         const commaSeparatedString = WebHookReceiverLogCheckedIds.join(', ');
//         dispatch(getWebhookRetryAsync(commaSeparatedString));
//     };
    
//     const handleFilterOnClickEvent = (selectedObject:any) => {
//         setSelectedOffCanvas(selectedObject);
//         setShowOffCanvas(true);
//     }
    
//     return (
//         <>
//              <div className="card card-custom admin-card">
//                 <div className="card-header sticky-top bg-white">
//                     <h3 className="card-title fw-bold mainHeading">{t('WebHook Receiver Log')}</h3>
//                     <div className="card-toolbar">
//                         <button type="button" className="btn btn-sm btn-danger"
//                             disabled={WebHookReceiverLogCheckedIds.length === 0 ? true : false}
//                             onClick={handleOnClickEvent}>
//                             {t('Retry Selected')}
//                         </button>
//                         &nbsp;
//                         <button 
//                             id="kt_OffCanvas" 
//                             type="button" 
//                             className="btn btn-light-primary btn-sm" 
//                             onClick={()=>handleFilterOnClickEvent(offCanvasList[0])}
//                         >
//                            {t('Filter')}
//                         </button>
//                     </div>
//                 </div>
//                 <div className="card-body">
//                     <div className="table-responsive">
//                         <WebHookReceiverLogItem 
//                             webHookReceiverLogDetail={WebHookReceiverLogList} 
//                             onhandleFilterOnClickEvent={handleFilterOnClickEvent} 
//                             offCanvasObject={offCanvasList[1]}
//                         />
//                     </div>
//                 </div>
//             </div>
//             <OffCanvas
//                 isOpen={showOffCanvas}
//                 onClose={() => setShowOffCanvas(false)}
//                 obj={selectedOffCanvas}
//             />
//         </>
//     )
// }

// export default WebHookReceiverLog;